module.exports = __webpack_public_path__ + "assets/sweetalert2.8a8fef5d.svg";